module.exports = __webpack_public_path__ + "media/images/grail-logo-b9afbe3630672e0cb3af091b216351d8.png";